// Shared agent × inbox auto-reply gate (REQ-20260813-02).
// Missing row / unknown inbox = on. Does not rewrite per-conversation flags;
// the conversation button shows the AND of this gate and the conversation flag.
import {
  fetchAgentInboxAutoReply,
  updateAgentInboxAutoReply,
} from './api';

const inboxKey = inboxId => String(inboxId);

const resolveAccountId = rootGetters =>
  rootGetters.getCurrentAccountId ||
  rootGetters['accounts/getCurrentAccountId'] ||
  null;

export const conversationAssignedTo = (chat, userId) => {
  const assigneeId = chat?.meta?.assignee?.id;
  return Boolean(userId && assigneeId && Number(userId) === Number(assigneeId));
};

const state = () => ({
  byInbox: {},
  loaded: {},
});

const getters = {
  agentInboxAutoReplyFor: state => inboxId => {
    if (inboxId == null || inboxId === '' || inboxId === 0) return true;
    return state.byInbox[inboxKey(inboxId)] !== false;
  },
};

const mutations = {
  SET_AGENT_INBOX_AUTO_REPLY(state, { inboxId, enabled }) {
    const id = inboxKey(inboxId);
    state.byInbox = { ...state.byInbox, [id]: enabled !== false };
    state.loaded = { ...state.loaded, [id]: true };
  },
};

const actions = {
  async loadAgentInboxAutoReply({ commit, state, rootGetters }, inboxId) {
    const id = Number(inboxId);
    if (!Number.isFinite(id) || id <= 0) return;
    if (state.loaded[inboxKey(id)]) return;
    const accountId = resolveAccountId(rootGetters);
    if (!accountId) return;
    try {
      const data = await fetchAgentInboxAutoReply(accountId, id);
      commit('SET_AGENT_INBOX_AUTO_REPLY', {
        inboxId: id,
        enabled: data.enabled !== false,
      });
    } catch (error) {
      commit('SET_AGENT_INBOX_AUTO_REPLY', { inboxId: id, enabled: true });
    }
  },

  async setAgentInboxAutoReply({ commit, rootGetters }, { inboxId, enabled }) {
    const id = Number(inboxId);
    const accountId = resolveAccountId(rootGetters);
    if (!accountId || !Number.isFinite(id) || id <= 0) return;
    const data = await updateAgentInboxAutoReply(accountId, id, enabled);
    commit('SET_AGENT_INBOX_AUTO_REPLY', {
      inboxId: id,
      enabled: data.enabled !== false,
    });
  },
};

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions,
};
